import { render, staticRenderFns } from "./AgentManagement.vue?vue&type=template&id=13856bb7"
import script from "./AgentManagement.vue?vue&type=script&lang=js"
export * from "./AgentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports